<template>
  <table>
    <thead>
      <tr>
        <th
          v-if="isTurnover"
          class="sticky top-0 left-0 z-10 bg-gray-50/90"
        ></th>
        <th
          v-for="(dataset, index) in data.datasets"
          :key="index"
          scope="col"
          class="sticky top-0 z-10 w-1 bg-gray-50/90 px-2 py-2 text-sm font-semibold"
        >
          <span v-if="dataset.label" class="whitespace-nowrap">
            {{ dataset.label }}
          </span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(label, index_label) in data.labels"
        :key="index_label"
        class="odd:bg-gray-200/90 even:bg-gray-50/90"
      >
        <td
          class="sticky left-2 max-w-48 truncate px-2 py-1 text-sm whitespace-nowrap sm:pl-0 xl:max-w-none"
          :style="{
            color: isTurnover
              ? 'text-gray-900'
              : data?.datasets[0]?.backgroundColor[index_label]
          }"
        >
          {{ label }}
        </td>
        <td
          v-for="(dataset, index_dataset) in data.datasets"
          :key="index_dataset"
          class="px-2 py-1 text-sm"
        >
          <span
            v-if="isTurnover"
            :style="{
              color: isTurnover
                ? data?.datasets[index_dataset]?.backgroundColor
                : data?.datasets[index_dataset]?.backgroundColor[index_label]
            }"
          >
            {{ $h.formatCurrency(dataset.data[index_label], currency) }}
          </span>
          <span v-else>
            {{ dataset.data[index_label] }}
          </span>
        </td>
        <td v-if="compare" class="px-2 py-2 text-right text-sm text-gray-900">
          <!--        {{-->
          <!--          Math.round(-->
          <!--              100 /-->
          <!--              (data.datasets[0].data[index_label] /-->
          <!--                  (data.datasets[1].data[index_label] - -->
          <!--                      data.datasets[0].data[index_label]))-->
          <!--          )-->
          <!--        }}-->
          <!--        %-->
        </td>
      </tr>
    </tbody>
  </table>
  <!--  {{ data }}-->
</template>

<script>
import { mapGetters } from 'vuex'
import JsonPretty from '@c/Utility/JsonPretty.vue'

export default {
  name: 'TableChart',
  props: {
    data: {
      type: Object,
      required: true
    },
    compare: {
      type: Boolean,
      required: false,
      default: false
    },
    isTurnover: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata',
      currency: 'metadata/getDefaultCurrencyMetadata'
    })
  }
}
</script>
